import { lazy } from 'react';

/** App dashboard routes — code-split from marketing bundle. */
export const DashboardPage = lazy(() => import('../pages/app/DashboardPage'));
export const EmployeesPage = lazy(() => import('../pages/app/EmployeesPage'));
export const EmployeeProfilePage = lazy(() => import('../pages/app/EmployeeProfilePage'));
export const ImportsPage = lazy(() => import('../pages/app/ImportsPage'));
export const RiskMapPage = lazy(() => import('../pages/app/RiskMapPage'));
export const ActionItemsPage = lazy(() => import('../pages/app/ActionItemsPage'));
export const ReportsPage = lazy(() => import('../pages/app/ReportsPage'));
export const SettingsPage = lazy(() => import('../pages/app/SettingsPage'));
